<!-- Permissions -->
<div [appEnforcePermission]="authConfig.timeEntryInvestigationHoursListOwnAssign"
  #timeEntryInvestigationHoursListOwnAssign="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.timeEntryInvestigationHoursCreateOwnAssign"
  #timeEntryInvestigationHoursCreateOwnAssign="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.timeEntryInvestigationHoursListAll"
  #timeEntryInvestigationHoursListAll="appEnforcePermission"></div>
<!-- Permissions -->

<div class="time-exp-header">
  <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(1,minmax(0,1fr))']"
    class="header-raw">
    <kendo-gridlayout-item class="mb-0 time-exp-title">
      <h3
        *ngIf="timeEntryInvestigationHoursListOwnAssign?.enabled || timeEntryInvestigationHoursCreateOwnAssign?.enabled || timeEntryInvestigationHoursListAll?.enabled"
        class="mb-0 ml-24">Time & Expense</h3>
      <p class="ml-24 mt-5">{{ investigation?.billingInstructions || '' }}</p>
    </kendo-gridlayout-item>
  </kendo-gridlayout>
  <div *ngIf="onSceneSummary?.length" class="ml-24 mt-8">
    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(4,minmax(0,1fr))']">
      <kendo-gridlayout-item>
        <p><strong>Name</strong></p>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <p><strong>Marked on Scene time</strong></p>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <p><strong>Marked off scene time</strong></p>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <p><strong>Duration</strong></p>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
    <kendo-gridlayout *ngFor="let item of onSceneSummary" [rows]="['auto']" [gap]="{rows: 5, cols: 16}"
      [cols]="['repeat(4,minmax(0,1fr))']">
      <kendo-gridlayout-item>
        <p>{{ item.user }}</p>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <p>{{ item?.startTime ?
          ((item?.startTime | dateWithTimezone : "MMMM DD, YYYY": investigation?.timezone) + ' at ' +
          (item?.startTime | dateWithTimezone : "hh:mm a": investigation?.timezone)) : '-'}}
          ({{investigation?.timezone || ''}})</p>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <p>{{ item?.endTime ?
          ((item?.endTime | dateWithTimezone : "MMMM DD, YYYY": investigation?.timezone) + ' at ' +
          (item?.endTime | dateWithTimezone : "hh:mm a": investigation?.timezone)) : '-'}}
          ({{investigation?.timezone || ''}})</p>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <p>{{ item.duration || '-' }}</p>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </div>
</div>
